import Timer from "../components/Timer";
import WordList from "../components/WordList";
import NewWordForm from "../components/NewWordForm";
import styles from "./MainPage.module.scss";
import VotingChart from "../components/VotingChart";
function MainPage() {
  return (
    <div>
      {/* <div className={styles.sidebar}>
        <NewWordForm maxInputLength={64}/>
        <hr />
        <Timer />
        <hr />
        <VotingChart limit={30}/>
      </div> */}
      <div className={styles.main}>
        <WordList />
      </div>
    </div>
  );
}

export default MainPage;
